///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------
//* \brief
//? Identification and contact details of the company behind programintrastat.ro.
//?
//? Single source of truth on purpose: these used to be written out by hand on the /info
//? page and again inside the terms, and the two drifted apart - the CUI was different in
//? each. Card processors verify these against the trade register, so one copy only.
//-----------------------------------------------------------------------------------------

export const COMPANY = {
    name: 'ASQUARED S.R.L.',
    regCom: 'J2024032303003',
    cui: 'RO50719801',
    address: 'Strada Hărmanului, Nr. 15, Bl. 30BIS, Ap. 10, camera 1',
    city: 'Brașov',
    county: 'Brașov',
    country: 'România',
    email: 'programintrastat@gmail.com',
    //? Deliberately not shown in the footer or on /info - published only within the terms
    //? and conditions. See PHONE_PUBLIC below before changing where this is rendered.
    phone: '0736433354',
    iban: 'RO58INGB0000999919581936',
    bank: 'ING BANK',
    site: 'programintrastat.ro'
}

//? Flip to true to also show the phone number in the footer and on /info. Card processors
//? expect a phone number among the published contact details, so if NETOPIA ever asks for
//? it during the site review, this is the switch.
export const PHONE_PUBLIC = false

//-----------------------------------------------------------------------------------------
//* \brief
//? Full postal address on one line.
//-----------------------------------------------------------------------------------------
export const fullAddress = () =>
    `${COMPANY.address}, ${COMPANY.city}, jud. ${COMPANY.county}, ${COMPANY.country}`
